import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { MunicipioModel } from '@data/municipio/models';

@Injectable()
export class MunicipioRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.MUNICIPIOS);
  }

  filter(search: string) {
    return this.getRequest<{ data: { results: MunicipioModel[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: String(item.descricao + ' - ' + item.estado),
          value: String(item.id),
        })),
      ),
    );
  }
}
